import { ref } from 'vue';
import { useApi, getHttpInstance, getApiConfig } from './useApi';
const REMINDERS_URL = '/Customers/00000000-0000-0000-0000-000000000000/Reminders';
const reminders = ref([]);
export function useReminders() {
    const api = useApi();
    /* Until the service ships, the endpoint may 404 (GET never calls back) or return a non-array; either way the You page section stays hidden */
    function getReminders() {
        api.GET(REMINDERS_URL, (result) => {
            reminders.value = (Array.isArray(result) ? result : [])
                .filter((r) => !r.dateTimeCompleted)
                .sort((a, b) => a.remindOnDateTime.localeCompare(b.remindOnDateTime));
        }, true);
    }
    /* So a reminder marked done can't reappear from the cached list */
    function clearRemindersCache() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + REMINDERS_URL);
    }
    function completeReminder(id) {
        reminders.value = reminders.value.filter((r) => r.id !== id);
        /* The body is a bare [FromBody] DateTime, so it goes as a JSON string */
        getHttpInstance().post(getApiConfig().api + REMINDERS_URL + '/' + id + '/Complete', JSON.stringify(new Date().toISOString()), {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(clearRemindersCache)
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => completeReminder(id));
            }
        });
    }
    function deleteReminder(id) {
        reminders.value = reminders.value.filter((r) => r.id !== id);
        getHttpInstance().delete(getApiConfig().api + REMINDERS_URL + '/' + id)
            .then(clearRemindersCache)
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteReminder(id));
            }
        });
    }
    /* completeReminder isn't wired up yet: the You page deletes for now */
    return { reminders, getReminders, completeReminder, deleteReminder };
}
